
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import procurementService from '../../services/procurementService';

export const fetchSuppliers = createAsyncThunk('procurement/fetchSuppliers', async (_, { getState }) => {
  return await procurementService.getSuppliers(getState().auth.token);
});
export const fetchStock = createAsyncThunk('procurement/fetchStock', async (_, { getState }) => {
  return await procurementService.getStock(getState().auth.token);
});
export const fetchOrders = createAsyncThunk('procurement/fetchOrders', async (_, { getState }) => {
  return await procurementService.getOrders(getState().auth.token);
});
export const createSupplier = createAsyncThunk('procurement/createSupplier', async (data, { getState }) => {
  return await procurementService.createSupplier(data, getState().auth.token);
});
export const createOrder = createAsyncThunk('procurement/createOrder', async (data, { getState }) => {
  return await procurementService.createOrder(data, getState().auth.token);
});

const procurementSlice = createSlice({
  name: 'procurement',
  initialState: {
    suppliers: [], stockItems: [], orders: [],
    loading: false, error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSuppliers.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchSuppliers.fulfilled, (state, action) => { state.loading = false; state.suppliers = action.payload; })
      .addCase(fetchSuppliers.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(fetchStock.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchStock.fulfilled, (state, action) => { state.loading = false; state.stockItems = action.payload; })
      .addCase(fetchStock.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(fetchOrders.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchOrders.fulfilled, (state, action) => { state.loading = false; state.orders = action.payload; })
      .addCase(fetchOrders.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(createSupplier.fulfilled, (state, action) => { state.suppliers.unshift(action.payload); })
      .addCase(createOrder.fulfilled, (state, action) => { state.orders.unshift(action.payload); });
  },
});

export default procurementSlice.reducer;
